import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import type { AppStore, AppState } from './types';
import { checkDevEnv } from '../utils/env';
import { createSingleKeySetter, type SingleKeySetter } from '@stores/utils';

const initialState: AppState = {
    isInitialized: false,
    isHydrated: false,
    currentOrganizationId: null,
    globalError: null,
};

const PREFIX = 'app';

export const useAppStore = create<AppStore>()(
    devtools(
        persist(
            (set) => {
                const createAppSetter = (
                    key: keyof AppState,
                ): SingleKeySetter<AppStore, keyof AppState> =>
                    createSingleKeySetter(set, key, PREFIX);

                return {
                    ...initialState,

                    setIsInitialized: createAppSetter('isInitialized'),

                    setIsHydrated: createAppSetter('isHydrated'),

                    setCurrentOrganizationId: createAppSetter(
                        'currentOrganizationId',
                    ),

                    setGlobalError: createAppSetter('globalError'),

                    clearGlobalError: (): void => {
                        set(
                            { globalError: null },
                            undefined,
                            `${PREFIX}/clearGlobalError`,
                        );
                    },

                    resetApp: (): void => {
                        set(initialState, undefined, `${PREFIX}/reset`);
                    },
                };
            },
            {
                name: 'dynoweb-app-store',
                partialize: (state) => ({
                    currentOrganizationId: state.currentOrganizationId,
                }),
                onRehydrateStorage:
                    (): ((state?: AppStore) => void) =>
                    (state): void => {
                        state?.setIsHydrated(true);
                    },
            },
        ),
        {
            name: 'AppStore',
            enabled: checkDevEnv(),
            store: 'AppStore',
        },
    ),
);
